export default __webpack_public_path__ + "static/media/user.2beed953.svg";